import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { useMemo } from "react";
export interface SelectAnoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  min?: number;
  max?: number;
}

function SelectAno({ value, min = 1990, max = 2099, ...rest }: SelectAnoProps) {
  const options = useMemo(() => {
    return new Array(max - min).fill(null).map((_, index) => ({
      value: (min + index).toString(),
      label: (min + index).toString(),
    }));
  }, [max, min]);

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      defaultValue={null}
      options={options}
      {...rest}
    />
  );
}

export default SelectAno;
